<template>
  <div>
    <div class="page_nav">
      <div class="page_games">
        <div
          v-for="gm in theTop4Games"
          :key="gm.gameId"
          class="page_game"
          :class="{ 
            page_game_active: gm.gameId === activeGameId,
            active_text: gm.gameId === activeGameId
          }"
          @click="handleChangeActiveGame(gm)"
        >
          <div
            class="page_game_icon bg_contain"
            :style="{
              backgroundImage: `url(${gm.gameIcon})`
            }"
          >
            <div
              v-if="gm.gameId === activeGameId"
              class="page_game_icon_cover bg_contain"
              :style="{
                backgroundImage: `url(${rootCDNUrl}/selected.png)`
              }"
            >

            </div>
          </div>
          <div class="page_game_name scale09_center">{{ gm.gameName }}</div>
        </div>
      </div>
      <div v-if="gameList.length > 4" class="page_more" @click="triggerMoreGame(true)">
        <div
          class="page_game_icon bg_contain"
          :style="{
            backgroundImage: `url(${rootCDNUrl}/more.png)`
          }"
        ></div>
        <div class="page_game_name scale09_center active_text">更多游戏</div>
      </div>
    </div>
    <ActivityPopup
      :visible.sync="visible"
      :headerStyle="{
        background: '#8a18e7'
      }"
      title="更多游戏"
      confirmButtonColor="#8a18e7"
      :showConfirmButton="false"
    >
      <div class="feedback">
        <div class="feedback_title">请选择</div>
        
        <div class="feedback_content">
          <div 
            v-for="item in gameList"
            :key="item.gameId"
            class="feedback_content_item flex_center"
            style="flex-direction: column;"
            @click="handleInnerChangeActiveGame(item)"
          >
            <img :src="item.gameIcon" class="feedback_content_item_icon"/>
            <div class="feedback_content_item_name">{{ item.gameName }}</div>
            <div
              v-if="item.playing"
              class="isPlay"
              :style="{ top: '-12px' }"
            >
              最近在玩
            </div>
          </div>
        </div>
      </div>
    </ActivityPopup>
  </div>
</template>

<script>
import ActivityPopup from '@/components/btBox/ActivityPopup.vue';
export default {
  props: {
    gameList: {
      type: Array,
      default: () => [],
    },
    activeGameId: {
      type: [Number, String],
      default: -1,
    },
  },
  components: {
    ActivityPopup,
  },
  data () { 
    return {
      rootCDNUrl: 'https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_wxDrawLottery',
      visible: false,
    }
  },
  computed: {
    theTop4Games () {
      const gList = this.gameList
      if (!Array.isArray(gList) || !gList.length) return []
      const maxCount = 4
      const currentIdx = gList.findIndex(it => it.gameId === this.activeGameId)
      const res = [gList[currentIdx]]
      gList.forEach(it => {
        if (res.length === maxCount) return
        if (it.gameId === this.activeGameId) return
        res.push(it)
      })
      return res
    },
    
  },
  methods: {
    triggerMoreGame (v) {
      this.visible = v
    },
    handleChangeActiveGame (game) {
      this.$emit('changeActiveGame', game)
    },
    handleInnerChangeActiveGame (game) {
      this.handleChangeActiveGame(game)
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
.isPlay {
  position: absolute;
  top: -18px;
  left: 42px;
  background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_payAmount/tips.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 30px;
  line-height: 24px;
  font-size: 12px;
  color: #fefefe;
  width: 64px;
  text-align: center;
  z-index: 1;
}
.feedback {
  max-height: 334px;
  overflow: auto;
  .feedback_title {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    color: #8A18E7;
  }
  .feedback_content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 18px;
    .feedback_content_item {
      width: 32%;
      margin-bottom: 14px;
      position: relative;
    }
    .feedback_content_item_icon {
      width: 58px;
      height: 58px;
    }
    .feedback_content_item_name {
      font-size: 12px;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
    }
  }
}
.page_nav {
  position: relative;
  display: flex;
  min-height: 84px;
  padding: 16px 68px 6px 14px;
  background: rgba(255, 255, 255, .45);
  border-radius: 5px;
}
.page_more {
  position: absolute;
  bottom: 6px;
  right: 12px;
}
.page_games {
  display: flex;
  width: 256px;
}
.page_game {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 64px;
}
.page_game_icon {
  width: 46px;
  height: 46px;
  margin-bottom: 4px;
  transition: 0.15s all ease;
  border-radius: 6px;
  flex-shrink: 0;
  filter: drop-shadow(-1px 1px 3px #333);
  .page_game_icon_cover {
    width: 54px;
    height: 54px;
    position: absolute;
    top: -4px;
    left: -4px;
  }
}
.page_game_name {
  width: 115%;
  font-size: 12px;
  text-align: center;
  // white-space: nowrap;
}
.page_game_active {
  opacity: 1;
  .page_game_icon {
    transform: scale(1.26);
    transform-origin: 50% 100%;
    border-radius: 10px;
  }
  .page_game_name {
    width: 130%;
    color: #FAD923;
  }
}
</style>